import { Outlet } from 'react-router-dom';

const Pitch = () => (
  <Outlet />
);

export default Pitch;
